import React from 'react';
import './ProfilCard.css';

const ProfilCard = ({ userData, onProfilePictureChange, onProfilePictureDelete, onProfileSave, selectedFile, previewImage, successMessage, handleFileChange, uploadProfilePicture }) => {
  return (
    <div className='profil-card'>
      {/* Titlu vizibil pe toate rezolutiile */}
      <h4 className='profil-card__desktop-title'>Profil</h4>
      {/* Titlu vizibil doar pe mobil */}
    
      <div className='profil-card__picture-section'>
        <div className='profil-card__picture-wrapper'>
          <div className='profil-card__picture-container'>
            <img
              src={previewImage || userData?.profile_picture || 'https://via.placeholder.com/150'}
              alt="Profile"
              className='profil-card__picture-img'
            />
            {previewImage && <div className='profil-card__preview-badge'>Preview</div>}
          </div>
          <div className='profil-card__picture-info'>
              <h5 className='profil-card__picture-title profil-card__hide-mobile'>Fotografie de profil</h5>
            <p className='profil-card__picture-description'>
              JPG, PNG sau GIF. Dimensiune maxima 5MB.<br />
              Imaginea va fi redimensionata automat la 400x400px.
            </p>
            <div className='profil-card__picture-actions'>
              <label className='profil-card__btn-upload'>
                {selectedFile ? 'Schimba imaginea' : 'Incarca imagine'}
                <input type="file" accept="image/*" onChange={handleFileChange} style={{ display: 'none' }} />
              </label>
              {selectedFile && (
                <button className='profil-card__btn-save-picture' onClick={uploadProfilePicture}>
                  Salveaza
                </button>
              )}
              {userData?.profile_picture && (
                <button className='profil-card__btn-delete-picture' onClick={onProfilePictureDelete}>
                  Sterge
                </button>
              )}
            </div>
            {successMessage && <div className='profil-card__alert-success'>{successMessage}</div>}
          </div>
        </div>
      </div>
      <form className='profil-card__form' onSubmit={onProfileSave}>
        <div className='profil-card__form-group'>
          <label className='profil-card__form-label'>Nume utilizator</label>
          <input
            type="text"
            className='profil-card__form-input'
            value={userData?.username || ''}
            placeholder="Introdu numele tau"
            readOnly
          />
        </div>
        <div className='profil-card__form-group'>
          <label className='profil-card__form-label'>Adresa de email</label>
          <input
            type="email"
            className='profil-card__form-input'
            value={userData?.email || ''}
            placeholder="email@example.com"
            disabled
          />
          <small className='profil-card__form-hint'>Email-ul nu poate fi modificat</small>
        </div>
        <button type="submit" className='profil-card__btn-save-profile'>
          <span>Salveaza modificarile</span>
        </button>
      </form>
    </div>
  );
};

export default ProfilCard;
